define(function (require, exports, module) {
    'use strict';

    /**
     * @type {TextEncoder|null}
     */
    var textEncoder = (function getTextEncoderIfSupported() {
        if (window.TextEncoder && window.Uint8Array) {
            var textEncoder;
            var bytes;

            try {
                textEncoder = new TextEncoder('utf-8');

                var uint8Array = textEncoder.encode('йё');

                bytes = uint8Array.length;
            } catch (reason) {}

            var result;

            if (bytes === 8) {
                result = textEncoder;
            } else {
                result = null;
            }

            return result;
        }
    })();

    /**
     * @type {boolean}
     */
    var hasBlobSupport = (function checkBlobSupport() {
        var bytes;

        try {
            var blob = new Blob(['йё']);

            bytes = blob.size;
        } catch (reason) {}

        var result = bytes === 8;

        return result;
    })();

    /**
     * @param {string} string
     * @returns {string}
     */
    function getStringLengthInBytes(string) {
        var bytes;

        if (textEncoder) {
            var uint8Array = textEncoder.encode(string);

            bytes = uint8Array.length;
        } else if (hasBlobSupport) {
            var blob = new Blob([string]);

            bytes = blob.size;
        } else {
            bytes = unescape(encodeURIComponent(string)).length;
        }

        return bytes;
    }

    module.exports = getStringLengthInBytes;
});
